module.exports = __webpack_public_path__ + "static/media/salad-image-3.7ce4b1a0.png";